export const CSV = 'csv';
export const JSON = 'json';
export const PDF = 'pdf';
export const ZIP = 'zip';



// WEBPACK FOOTER //
// src/constants/format.js